<template>
    <div class="login-container">
      <a-row>
        <a-col :xs="0"  :sm="8" :md="8" :lg="14" :xl="15"></a-col>
        <a-col :xs="24" :sm="16" :md="16" :lg="10" :xl="7">
          <div class="login-container-form">
            <div class="login-container-hello">hello!</div>
            <div class="login-container-title">欢迎来到 {{ title }}</div>
            <a-form :model="form" @submit="handleSubmit" @submit.prevent>
              <a-form-item>
                <a-input v-model:value="form.username" placeholder="请输入用户名">
                  <template v-slot:prefix>
                    <UserOutlined style="color: rgba(0, 0, 0, 0.25)" />
                  </template>
                </a-input>
              </a-form-item>
              <a-form-item>
                <a-input
                  v-model:value="form.password"
                  type="password"
                  placeholder="请输入密码"
                >
                  <template v-slot:prefix>
                    <LockOutlined style="color: rgba(0, 0, 0, 0.25)" />
                  </template>
                </a-input>
              </a-form-item>
              <a-form-item>
                <div style="display: flex; gap: 10px;">
                    <a-input
                      v-model:value="form.captcha"
                      placeholder="请输入验证码"
                      style="flex: 1"
                    >
                    <template v-slot:prefix>
                        <SafetyOutlined style="color: rgba(0, 0, 0, 0.25)" />
                    </template>
                    </a-input>
                    <a-button
                        :disabled="!form.username || countdown > 0"
                        @click="getCaptcha"
                        :loading="captchaLoading"
                        style="width: 120px; border-radius: 6px; background-color: #fff;"
                    >
                        获取验证码
                    </a-button>
                </div>
              </a-form-item>
              <a-form-item v-if="countdown > 0">
                <div style="color: #fff">
                  {{ `请于${Math.floor(countdown/60)}分钟${countdown%60}秒后请求发送验证码` }}
                </div>
              </a-form-item>
              <a-form-item>
                <a-button
                  type="primary"
                  html-type="submit"
                  :disabled="form.username === '' || form.password === ''"
                  :loading="loading"
                >
                  登录
                </a-button>
              </a-form-item>
            </a-form>
          </div>
        </a-col>
      </a-row>
      <div class="login-container-tips"></div>
    </div>
</template>
<script setup>
    import { watch, ref, onMounted, computed, toRefs } from 'vue'
    import { mapActions, mapGetters, useStore } from 'vuex'
    import { useRoute } from 'vue-router'
    import { UserOutlined, LockOutlined, SafetyOutlined } from '@ant-design/icons-vue'
    import { encrypt } from '@/utils/auth'
    import { router } from '@/main'
    import { getModal } from '@/api/system_manage/modal'
    import { captcha } from '@/api/user'
    import { getDept } from '@/api/system_manage/dept'
    import { getData as getGate } from '@/api/equipment_management/gate'
    import { getUser } from '@/api/system_manage/userManage'
    import { allEnum } from '@/utils/common'
    import { getEnum } from '@/api/common'
    import { capitalizeFirstLetter, resListToEnum } from '@/utils/format'
    import { message } from 'ant-design-vue'
    const store = useStore()
    const route = useRoute()
    const form = ref({
      username: '',
      password: '',
      captcha: ''
    })
    const redirect = ref(undefined)
    const loading = ref(false)
    const captchaLoading = ref(false)
    const countdown = ref(0)
    const login = mapActions({ login: 'user/v2login' }).login.bind({
      $store: store,
    })
    
    async function getCaptcha() {
      captchaLoading.value = true
      const obj = {
        account: form.value.username
      }
      const encryptedStr = encrypt(obj, config.value.publicKey)
      try {
        const { data } = await captcha({ content: encryptedStr })
        message.success('验证码发送成功')
        countdown.value = data.expireOfSeconds;
        const timer = setInterval(() => {
          countdown.value--
          if (countdown.value <= 0) {
            clearInterval(timer)
          }
        }, 1000)
      } catch (error) {
        message.error('验证码发送失败')
      } finally {
        captchaLoading.value = false
      }
    }
  
    const { 'user/config': config, 'settings/title': title } = toRefs(
      store.getters
    )
  
    watch(
      route,
      function handler(route) {
        redirect.value = (route.query && route.query?.redirect) || '/'
      },
      { immediate: true }
    )
  
    onMounted(() => {
      if (process.env.NODE_ENV === 'development') {
        form.value.username = 'yisa'
        form.value.password = 'Yisa@123456'
      }
    })
    function handleRoute() {
      return redirect.value === '/404' || redirect.value === '/403'
        ? '/'
        : redirect.value
    }
    async function handleSubmit() {
      loading.value = true
      setTimeout(() => {
        loading.value = false
      }, 10 * 1000)
      const obj = {
        account: form.value.username,
        password: form.value.password,
        captcha: form.value.captcha
      }
      const encryptedStr = encrypt(obj, config.value.publicKey)
      const res = await login({ content: encryptedStr }).catch(
        () => (loading.value = false)
      )
      router.push(handleRoute())
      loading.value = false
      if (res.success) {
        getAllEnum()
      } else {
        message.warn('登录失败' + res.message)
      }
    }
  
    //获取所有映射表
    function getAllEnum() {
      for (let i in allEnum) {
        const item = allEnum[i]
        let name = item,
          value = item
        if (item.constructor === Object) {
          name = item.name
          value = item.value
        }
        getEnum({ name }).then((res) => {
          if (res.success) {
            const actionName = 'common/set' + capitalizeFirstLetter(value)
            store.dispatch(actionName, res.data)
          }
        })
      }
  
      getModal({
        size: Number.MAX_SAFE_INTEGER,
        pn: 1,
      }).then((res) => {
        store.dispatch(
          'common/setCarModel',
          resListToEnum(res.data.list, { toString: true })
        )
        store.dispatch(
          'common/setCarModelObj',
          resListToEnum(res.data.list, { saveData: true })
        )
      })
  
      getDept().then((res) => {
        store.dispatch(
          'common/setDept',
          resListToEnum(res.data, { idName: 'depart_id' })
        )
      })
      getGate({
        size: 999,
        pn: 1,
        state: -1,
        type: -1,
      }).then((res) => {
        store.dispatch('common/setGate', resListToEnum(res.data.list));

        let carGate = [];
        let personGate = [];

        for (let i = 0; i < res.data.list.length; i++) {
          let item = res.data.list[i];
          if(item['type'] == 1) {
            carGate.push(item);
          } else if (item['type'] == 2) {
            personGate.push(item);
          }
        }
        store.dispatch('common/setCarGate', resListToEnum(carGate));
        store.dispatch('common/setPersonGate', resListToEnum(personGate));
      })
      getUser({
        size: 999999,
        pn: 1,
      }).then((res) => {
        store.dispatch(
          'common/setUser',
          resListToEnum(res.data.list, {
            idName: 'user_id',
            valueName: 'user_name',
          })
        )
      })
    }
</script>
<style lang="less">
    .login-container {
      width: 100%;
      height: 100vh;
      background: url('~@/assets/login_images/login_background.png');
      background-size: cover;
      &-form {
        width: calc(100% - 40px);
        height: auto;
        padding: 4vh;
        margin-top: calc((100vh - 380px) / 2);
        margin-right: 20px;
        margin-left: 20px;
        background: url('~@/assets/login_images/login_form.png');
        background-size: 100% 100%;
        border-radius: 10px;
        box-shadow: 0 2px 8px 0 rgba(7, 17, 27, 0.06);
      }
      &-hello {
        font-size: 32px;
        color: #fff;
      }
      &-title {
        margin-bottom: 30px;
        font-size: 20px;
        color: #fff;
      }
      &-tips {
        position: fixed;
        bottom: @vab-margin;
        width: 100%;
        height: 40px;
        color: rgba(255, 255, 255, 0.856);
        text-align: center;
      }
      .ant-col {
        width: 100%;
        padding: 0 10px 0 10px;
      }
      .ant-input {
        height: 35px;
      }
      .ant-btn {
        width: 100%;
        height: 45px;
        border-radius: 99px;
      }
    }
</style>
